module.exports = __webpack_public_path__ + "img/CameraHigh.8fcb765d.svg";